import { useParticipantStore } from '@/stores/participant';
import type { PreloadHandler } from '@/types/router';

export const preloadRoles: PreloadHandler = async () => {
  const { listRoles } = useParticipantStore();

  await listRoles();
};
